<template>
  <div>
    <div v-html="news.newsdesc"></div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      news:this.$route.query
    }
  },
  created(){
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/preview.vue